import React, { Component, Fragment } from "react";
import DeleteModel from "./DeleteModel";
import UpdateModel from "./UpdateModel";
import AppContext from "../../../contexts/AppContext";

class List extends Component {
    state = {
        delete: false,
        update: false,
        item: {}
    };

    /* delete */
    delete = () => {
        return this.props.delete(this.props.item.id);
    };
    toggleDelete = () => {
        this.setState({ delete: this.state.delete === true ? false : true });
    };

    /* update */
    toggleUpdate = () => {
        this.state.update === true
            ? this.setState({ update: false })
            : this.props
                  .getItem(this.props.item.id)
                  .then(response => {
                      this.setState({ update: true, item: response.data });
                  })
                  .catch(error => {
                      this.context.state.handelError(error);
                  });
    };

    render() {
        return (
            <Fragment>
                <tr>
                    <td>{this.props.item.id}</td>
                    <td>{this.props.item.name}</td>
                    <td className="large">{this.props.item.main}</td>
                    <td className="large">{this.props.item.description}</td>
                    <td>
                        <time dateTime={this.props.item.created_at}>
                            {this.props.item.created_at}
                        </time>
                    </td>

                    <td className="text-right large">
                        <button
                            onClick={this.toggleUpdate}
                            type="button"
                            className="btn btn-success btn-sm"
                        >
                            Edit
                        </button>
                        <button
                            onClick={this.toggleDelete}
                            type="button"
                            className="btn btn-danger btn-sm ml-2"
                        >
                            Delete
                        </button>
                    </td>
                </tr>
                {this.state.delete === true ? (
                    <DeleteModel
                        delete={this.delete}
                        hideDelete={this.toggleDelete}
                    ></DeleteModel>
                ) : null}
                {this.state.update === true ? (
                    <UpdateModel
                        item={this.state.item}
                        update={this.props.update}
                        hideUpdate={this.toggleUpdate}
                    ></UpdateModel>
                ) : null}
            </Fragment>
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/admin/employerPlans/List.js